import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '@material-ui/core';
import FileUploadIcon from '@material-ui/icons/CloudUploadTwoTone';
import FilePicker from '../FilePicker';

const FileUpload = ({ file, onFilePicked }) => {
  let requestFilePickerOpen = null;
  return (
    <div>
      {!file ? null : <Typography color="textSecondary">{file.name}</Typography>}
      {!file ? <Button size="small" color="primary" onClick={() => requestFilePickerOpen()}>
        <FileUploadIcon style={{marginRight: 10}} /> Wybierz plik ...
      </Button> : null}
      <FilePicker
        onFilePicked={onFilePicked}
        ref={picker => requestFilePickerOpen = picker && picker.onFilePickerOpenRequest.bind(picker)}
      />
    </div>
  );
};

FileUpload.propTypes = {
  file: PropTypes.object,
  onFilePicked: PropTypes.func.isRequired,
};

export default FileUpload;


// WEBPACK FOOTER //
// ./src/components/common/FileUpload.js